'use client';

import React from 'react';
import { Badge } from '@/components/ui/design-system';
import { motion } from 'framer-motion';

/**
 * Form Header Component
 * Displays the title and intro text for the contact form
 */
export default function FormHeader() {
  return (
    <div className="text-center space-y-6">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="flex flex-col items-center space-y-3"
      >
        <Badge variant="premium" size="lg" radius="full">Get in Touch</Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">Let's Start Your Project</h2>
        <div className="w-20 h-1 bg-gradient-to-r from-red-500 to-red-600 rounded-full"></div>
        <p className="text-gray-600 dark:text-gray-300 max-w-lg text-base md:text-lg leading-relaxed">
          Ready to elevate your packaging? We're just a message away from bringing your vision to life.
        </p>
      </motion.div>
    </div>
  );
} 